import { render, staticRenderFns } from "./DicRadioButton.vue?vue&type=template&id=d1d1ec8c&scoped=true&"
import script from "./DicRadioButton.vue?vue&type=script&lang=js&"
export * from "./DicRadioButton.vue?vue&type=script&lang=js&"
import style0 from "./DicRadioButton.vue?vue&type=style&index=0&id=d1d1ec8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d1ec8c",
  null
  
)

export default component.exports